export default __webpack_public_path__ + "static/media/CircleCancel.2fcc6e02.svg";